
<template>
  <div id="app-footer" class="app-footer" :class="isFullWidth ? 'app-footer__full-width' : ''">
    <div class="app-footer__left">
      <svg
        width="135"
        height="31"
        viewBox="0 0 135 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.1797 21.6665V8.46875H44.6916L49.1415 18.3313L53.5254 8.46875H56.8898V21.6665H53.9938V13.9888L50.6525 21.6665H47.5656L44.1813 14.0306V21.6665H41.1797Z"
          fill="var(--maersk-logo-color)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M68.544 16.5566L66.1209 10.9623L63.7534 16.5566H68.544ZM61.5873 21.6665H58.1816L64.0358 8.46875H68.2286L74.1246 21.6665H70.7629L69.6026 19.0376H62.7119L61.5873 21.6665Z"
          fill="var(--maersk-logo-color)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M75.4824 21.6665V8.46875H88.0835V11.1076H78.5259V13.7289H86.7206V16.3045H78.5259V19.0265H88.1066V21.6665H75.4824Z"
          fill="var(--maersk-logo-color)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M93.644 14.5288H100.265V11.1076H93.644V14.5288ZM90.5576 21.6665V8.46875H101.102C102.511 8.46875 103.329 9.28398 103.329 10.6821V15.1161C103.329 16.1361 102.426 17.0581 100.674 17.0581C100.575 17.0631 100.474 17.0581 100.37 17.0581L103.439 21.6665H100.052L97.1417 17.1539H93.644V21.6665H90.5576Z"
          fill="var(--maersk-logo-color)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M108.882 21.6743H107.837C106.473 21.6743 105.816 20.886 105.816 19.7383V18.0143H108.882V19.0354H115.395V16.3337C115.395 16.3337 109.116 16.3337 107.924 16.3337C106.731 16.3337 105.872 15.5317 105.872 14.4187V10.5005C105.872 9.31485 106.807 8.47705 107.945 8.47705C109.082 8.47705 116.486 8.47705 116.486 8.47705C117.64 8.47705 118.439 9.33852 118.439 10.5842C118.439 11.8282 118.439 12.1591 118.439 12.1591H115.395V11.1159H108.882V13.7152H116.332C117.432 13.7152 118.439 14.4429 118.439 15.8438V19.6106C118.439 20.8937 117.727 21.6743 116.396 21.6743C115.065 21.6743 108.882 21.6743 108.882 21.6743Z"
          fill="var(--maersk-logo-color)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M121.381 21.6742V8.47534H124.51V13.7542L130.469 8.47534H134.706L127.596 14.6064L134.962 21.6742H130.576L124.51 15.6709V21.6742H121.381Z"
          fill="var(--maersk-logo-color)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.5544 26.6306C28.5544 28.517 27.0258 30.0462 25.1394 30.0462H3.58119C1.69421 30.0462 0.165039 28.517 0.165039 26.6306V3.50306C0.165039 1.61664 1.69421 0.0869141 3.58119 0.0869141H25.1394C27.0258 0.0869141 28.5544 1.61664 28.5544 3.50306V26.6306Z"
          fill="#42B0D5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.8856 14.2892L24.4876 7.26368L24.47 7.24111L16.3739 11.14L14.3741 2.37891H14.346L12.3462 11.14L4.25002 7.24111L4.23241 7.26368L9.83498 14.2892L1.73828 18.1881L1.74544 18.2156H10.7311L8.73131 26.9773L8.75663 26.9888L14.3603 19.9633L19.9629 26.9888L19.9882 26.9762L17.9895 18.2156H26.9752L26.9818 18.1881L18.8856 14.2892Z"
          fill="#FFFFFE"
        />
      </svg>
      <br />© A.P. Moller – Maersk <br />Made with
      <span role="img" aria-label="love">💖</span>
      by Team Anchor
      <span class="app-footer__left__build-version">
        (Build v{{ appVersion }})
      </span>
    </div>
    <div class="app-footer__right">
      <p class="app-footer__right__contact-us">
        <span>
          <a
            :href="contactUsUrl"
            target="_blank"
            title="Contact us"
            rel="noopener noreferrer"
            to="/bar"
          >
            Contact us
          </a>
        </span>
      </p>
      <p class="app-footer__right__faqs">
        <span>
          <router-link to="/faq"> FAQ </router-link>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    contactUsUrl: {
      type: String,
      default: "",
    },
    appVersion: {
      type: String,
      default: "",
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
  
<style lang="scss">
.app-footer {
  display: flex;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
  margin-top: 54px;
  padding-bottom: 24px;
  p {
    font-size: 12px;
    font-family: "Maersk Text";
    color: var(--primary-text);
  }
  &__left {
    padding-left: 24px;
    width: 50%;
    @media (min-width: 1400px) {
      padding-left: 0;
    }
  }
  &__right {
    padding-right: 24px;
    width: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    p {
      margin-right: 24px;
      a {
        color: var(--primary-text);
      }
    }
  }
  &__full-width{
    padding: 0 48px 24px;
    max-width: unset;
  }
}
</style>